import React from "react";
import { useAuth } from "../auth/useAuth";
import { NavDropdown, OverlayTrigger, Tooltip } from "react-bootstrap";
import "./UserNav.scss";
import { processImagePath } from "../util/Functions";
import Associate from "../models/Associate";

const InviteUserModal = React.lazy(() => import("../layouts/protected/pages/profileGroup/components/InviteUserModal"));
const ChangeLocationModal = React.lazy(() => import("../layouts/protected/pages/profileGroup/components/ChangeLocationModal"));
const ChangeOrganizationMemberModal = React.lazy(() => import("../layouts/private/components/associate/ChangeOrganizationMemberModal"));

function UserNav({ className }) {
	const { currentUser, logout, organizationMember } = useAuth();

	const [showInviteModal, setShowInviteModal] = React.useState(false);
	const [showLocationModal, setShowLocationModal] = React.useState(false);
	const [showChangeAssociate, setShowChangeAssociate] = React.useState(undefined);
	const [allowSwitchAssociate, setAllowSwitchAssociate] = React.useState(undefined);
	const checkAllowSwitchAssociate = React.useRef(undefined);

	function open_location_modal() {
		setShowLocationModal(true);
	}

	const relocate = React.useCallback(dest => {
		window.location.href = dest;
	}, []);

	const organization_member_data = JSON.parse(localStorage.getItem('organization_member:data')) || organizationMember;
	const isAdmin = organization_member_data?.role?.is_administrator === true;

	// check if allowed to access associate list
	const checkAssociatesPermissions = async () => {
		checkAllowSwitchAssociate.current = true;
		try {
			await Associate.FetchBy({
				filter: [{ property: "id", value: 0 }]
			})
			setAllowSwitchAssociate(true);
		}
		catch (e) { }
	}

	React.useEffect(() => {
		if (!checkAllowSwitchAssociate.current) {
			checkAssociatesPermissions();
		}
	}, []);

	return (
		<NavDropdown
			className={[className, "user-nav"].filter(c => c).join(" ")}
			title={
				<OverlayTrigger placement="bottom" overlay={
					<Tooltip className="_boss tooltip">Associate</Tooltip>
				}>
					<div data-component="UserNav">
						{currentUser?.picture
							? (<img src={processImagePath(currentUser?.picture)} alt="Profile" />)
							: (<>{(currentUser?.given_name ?? currentUser?.family_name ?? "?").at(0).toUpperCase()}</>)
						}
					</div>
				</OverlayTrigger>
			}
		>
			<NavDropdown.Item onClick={() => relocate("/user/profile")}>
				{currentUser?.username}
			</NavDropdown.Item>

			{/*
			 * If we use navigate() it does not re-trigger the Appin.js router
			 * and therefore is not switching to protected version.
			 */}
			{organization_member_data?.organization?.id && isAdmin === true && (
				<NavDropdown.Item onClick={() => relocate("/user/profile-group")}>
					Manage Organizations
				</NavDropdown.Item>
			)}

			{showChangeAssociate && (
				<React.Suspense fallback={<></>}>
					<ChangeOrganizationMemberModal onClose={() => setShowChangeAssociate(false)} />
				</React.Suspense>
			)}

			{organization_member_data?.organization?.id && isAdmin === false && (
				<>
					<NavDropdown.Item onClick={() => setShowInviteModal(true)}>
						Invite Team Members
					</NavDropdown.Item>
					{showInviteModal && (
						<React.Suspense fallback={<></>}>
							<InviteUserModal
								close_modal={() => setShowInviteModal(false)}
								organization_id={organization_member_data?.organization?.id}
							/>
						</React.Suspense>
					)}

					<NavDropdown.Item onClick={open_location_modal}>
						Change Locations
					</NavDropdown.Item>
					{showLocationModal && (
						<React.Suspense fallback={<></>}>
							<ChangeLocationModal
								close_modal={() => setShowLocationModal(false)}
							/>
						</React.Suspense>
					)}
				</>
			)}

			<NavDropdown.Divider />
			<NavDropdown.Item onClick={() => relocate("/catalog/select")}>
				Select Catalog
			</NavDropdown.Item>

			<NavDropdown.Divider />

			{allowSwitchAssociate && (
				<NavDropdown.Item onClick={() => setShowChangeAssociate(true)}>
					Switch Associate
				</NavDropdown.Item>
			)}

			<NavDropdown.Item onClick={() => logout()}>
				Logout
			</NavDropdown.Item>
		</NavDropdown>
	);
}

export default UserNav;
